export default "__VITE_ASSET__C4Pv0d5B__"